import DOMPurify from 'dompurify';

/**
 * Central HTML sanitizer for any rich-text/HTML that is rendered via v-html
 * (or the `v-safe-html` directive). Strips <script>, event handlers,
 * javascript: URLs and other XSS vectors while preserving the formatting,
 * links and images legitimate rich-text content relies on.
 *
 * Used for tenant/user-supplied content such as CV-derived worker summaries,
 * email signatures, campaign/job descriptions, KB markdown and agency footers.
 */

// Force any anchor that opens in a new tab to also drop the opener reference,
// closing the reverse-tabnabbing hole DOMPurify does not address on its own.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node instanceof HTMLElement && node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export function sanitizeHtml(dirty: string | null | undefined): string {
  if (!dirty) return '';
  return DOMPurify.sanitize(String(dirty), { USE_PROFILES: { html: true } });
}

export default sanitizeHtml;
